<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-7 col-md-7 col-xs-12 col-sm-12 mt-1">
                <router-link to="/event/new" class="btn btn-info"><i class="fa fa-plus"></i> Adicionar
                    evento</router-link>
            </div>
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-3 offset-md-3  mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light ml-2 " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <label for="">Descrição</label>
                            <input type="text" id="description" class="form-control" placeholder="Ex: Caixa geral"
                                v-model="advanced_search_input.name">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i> Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i> Limpar</button>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Eventos
                            <br><small><span v-if="total_itens > 0">Total registros encontrados: {{
                                    formatDecimal(total_itens) }}</span></small>
                        </h6> <button class="btn btn-warning btn-sm" @click="loadData()"><i class="fa fa-undo"></i>
                            Recarregar dados</button>
                    </div>
                    <div class="card-body" :class="events.length <= 0 ? 'card-body-no-spaccing' : ''">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th  class="text-center">Notificação e-mail</th>
                                        <th  class="text-center">Notificação whatsapp</th>
                                        <th  class="text-center">Criação atividade</th>
                                        <th  class="text-center">Status</th>
                                        <th  class="text-center">Criado em</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(event) in events" :key="event.id">
                                        <td>{{ event.type }} </td>
                                        <td class="text-center"><span class="badge" :class="event.email?'badge-success':'badge-danger'">{{ event.email?'Sim':'Não' }}</span> </td>
                                        <td  class="text-center"><span class="badge" :class="event.whatsapp?'badge-success':'badge-danger'">{{ event.whatsapp?'Sim':'Não' }}</span> </td>
                                        <td  class="text-center"><span class="badge" :class="event.create_activity?'badge-success':'badge-danger'">{{ event.create_activity?'Sim':'Não' }}</span> </td>
                                        <td  class="text-center"><span class="badge" :class="event.status?'badge-success':'badge-danger'">{{ event.email?'Ativo':'Desativado' }}</span> </td>
                                        <td  class="text-center">{{ event.created_at }}</td>
                                        <th></th>
                                    </tr>
                                    <tr v-if="events.length > 0 && page > 1">
                                        <td colspan="4" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="events.length <= 0">
                                        <td colspan="6" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: {},
            events: [],
            url_api: '',
            page: 1,
            last_page: 1,
            total_itens: 0
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        }
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.events = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.events = {}
            this.advanced_search_input = {}
            this.loadData();
        },
        formatDecimal(number) {
            return new Intl.NumberFormat().format(number)
        },

        loadData() {
            this.isLoading = true;
            api.get('/event', {
                params: {
                    'name': this.advanced_search_input.name,
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.total_itens = response.data.total_itens;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.events = response.data.data;
                    } else {
                        this.events = this.events.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        deleteEvent(id) {
            this.$confirm(
                {
                    message: 'Deseja apagar o evento?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/event/' + id)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Evento excluído com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        }

    },
    mounted() {
        this.url_api = process.env.VUE_APP_URL_API
        this.loadData();

    },
}
</script>

<style></style>